import CloseCarbon_logo2 from "../../images/CloseCarbon_logo2.png";
import { Link } from "react-router-dom";

function GetStarted() {
  const leftPlans = [
    {
      title: "Basic Plan",
      link: "/plans/basic",
      description:
        "The basic plan is tailored for facilities looking to track their carbon emissions, emission reduction, and earn carbon incentives from the emission reduced.",
    },
    {
      link: "/plans/governance",
      title: "Governance Plan",
      description:
        "The governance plan is designed for governments and private organisations seeking to monitor activities aligned with Nationally Determined Contributions (NDCs) and generate value from verified emissions reduction.",
    },
    {
      title: "Verifier’s Plan",
      link: "/plans/verifier",
      description:
        "Whether you’re a beginner in your career or you’re already an established verifier, this plan offers a pivotal role in ensuring the accuracy and integrity of emission data.",
    },
  ];

  const rightPlans = [
    {
      title: "Business Plan",
      link: "/plans/business",
      description:
        "The business plan is a paid plan designed for facilities looking to download their carbon emissions report and obtain a carbon monitoring certificate. It also includes energy efficiency insights to help facilities optimise energy use and reduce emissions. This plan is ideal for facilities assigned to a specific sub-CCV (verifier) for their facility.",
    },
    {
      title: "Business Plus Plan",
      link: "/plans/business-plus",
      description:
        "The business plus plan is a paid plan for facilities that offers powerful tools, for energy sharing and energy efficiency tracking, to help optimize consumption and trade surplus energy. It also include access to downloadable carbon report and official carbon monitoring certificate",
    },
  ];

  return (
    <section className="w-full xl:h-[1204px] bg-[#E7F6EC] flex flex-col items-start gap-2.5 overflow-hidden px-4 sm:px-8 xl:px-0">
      <div className="w-full max-w-full flex flex-col gap-6 xl:gap-12 mx-auto pt-16 sm:pt-24 lg:pt-32 xl:pt-44">
        {/* Header */}
        <div className="flex flex-col gap-3 md:ml-64">
          <h2 className="font-bold text-[26px] sm:text-[30px] xl:text-[36px] text-[#3B3B3B]">
            Get Started
          </h2>
          <p className="font-normal text-[16px] xl:text-[18px] text-[#3B3B3B]">
            Take the bold step today!
          </p>
        </div>

        {/* Two columns */}
        <div className="flex flex-col xl:flex-row items-center gap-6 justify-center">
          {/* Left column - 3 cards */}
          <div className="w-full xl:w-[757px] flex flex-col gap-6">
            {leftPlans.map((plan, idx) => (
              <div
                key={idx}
                className="w-full xl:max-h-[262px] bg-white rounded-2xl p-6 flex flex-col gap-2.5"
              >
                {/* Hidden MetaMask icon placeholder - ignored */}
                {/* Content container */}
                <div className="w-full flex flex-col gap-6">
                  {/* Logo */}
                  <div className="w-10 h-10 relative">
                    <div className="bg-[#006633]/10 rounded-xl w-[40px] h-[40px] p-3 mb-5">
                      <img className=" " src={CloseCarbon_logo2} />
                    </div>
                  </div>
                  {/* Text and button */}
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-3">
                      <h3 className="font-medium text-[22px] xl:text-[24px] leading-[29px] text-[#141414] mt-10">
                        {plan.title}
                      </h3>
                      <p className="font-medium text-[16px] text-[#898989]">
                        {plan.description}
                      </p>
                    </div>
                    {/* Button */}
                    <Link
                      to={plan.link}
                      className="flex flex-row justify-center items-center px-[18px] py-3 gap-2.5 w-[132px] h-[47px] bg-[#0D924F] hover:bg-[#097B42] border-2 border-[#E4E7EC] rounded-[8px]"
                    >
                      <span className="font-medium text-[14px] text-white rounded-[8px] ">
                        Choose plan
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* Right column - 2 cards */}
          <div className="w-full xl:w-[419px] flex flex-col gap-[16px]">
            {rightPlans.map((plan, idx) => (
              <div
                key={idx}
                className="w-full xl:max-h-[450px] bg-white rounded-2xl p-[25px_25px] pb-5 flex flex-col gap-2.5"
              >
                <div className="w-full flex flex-col">
                  {/* Logo */}
                  <div className="w-10 h-10 relative">
                    <div className="bg-[#006633]/10 rounded-xl w-[40px] h-[40px]">
                      <img className=" " src={CloseCarbon_logo2} />
                    </div>
                  </div>
                  {/* Text and button */}
                  <div className="flex flex-col gap-6">
                    <div className="flex flex-col gap-3">
                      <h3 className="font-medium text-[22px] xl:text-[24px] text-[#141414] mt-10">
                        {plan.title}
                      </h3>
                      <p className="font-medium text-[16px] text-[#898989]">
                        {plan.description}
                      </p>
                    </div>
                    {/* Button */}
                    <Link
                      to={plan.link}
                      className="flex mb-3 flex-row justify-center items-center px-[18px] py-3 gap-2.5 w-[132px] h-[47px] bg-[#0D924F] hover:bg-[#097B42] border-2 border-[#E4E7EC] rounded-lg"
                    >
                      <span className="font-medium text-[14px] text-white">
                        Choose plan
                      </span>
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}

export default GetStarted;